import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryConfig } from '../baseQueryConfig '

// authApi contains all the endpoints we want to use in the authentication
export const paymentApi = createApi({
  reducerPath: 'paymentApi',
  baseQuery: baseQueryConfig,
  tagTypes: ['PAYMENT'],
  endpoints: (builder) => ({
    createPayment: builder.mutation({
      query: (paymentRequest) => ({
        url: 'paypal/create-payment',
        method: 'POST',
        body: paymentRequest,
      }),
    }),
  }),
})

// Export hooks
export const { useCreatePaymentMutation } = paymentApi
export default paymentApi
